/* Ortak clipboard util — iframe/permission-policy engelli ortamlarda güvenli kopyalama.
 * 3-katlı fallback: navigator.clipboard → execCommand → prompt
 * Preview iframe'de clipboard bloklanabilir, bu helper hiçbir durumda uncaught atmaz.
 */
import { toast } from 'sonner';

export const safeCopy = async (text, label = 'Kopyalandı') => {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            if (label) toast.success(label);
            return true;
        }
    } catch { /* fall through */ }
    try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.top = '0';
        ta.style.left = '0';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        const ok = document.execCommand('copy');
        document.body.removeChild(ta);
        if (ok) {
            if (label) toast.success(label);
            return true;
        }
    } catch { /* fall through */ }
    try {
        window.prompt('Kopyalanacak (Ctrl+C ile alın):', text);
        return true;
    } catch {
        toast.error('Kopyalanamadı — manuel seçin');
        return false;
    }
};
